import { useEffect, useState, useCallback } from "react";
import axios from "../../../axios/axios";
import LoadingOverlay from "react-loading-overlay";
import { Button, Form, Modal } from "react-bootstrap";
import { message } from "antd";
import { adminConfig } from "../../../utils/adminConfig";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import Select from "react-select";

export default function GenerateCodeEscapeBucksProduct() {
  const [loading, setLoading] = useState(false);
  //const [allProducts, setAllProducts] = useState([]);
  const [productsByCategory, setProductsByCategory] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [corporateUsers, setCorporateUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    userId: {},
    categoryId: "",
    productId: "",
    count: "",
  });
  const [allCode, setAllCode] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [showCSVModal, setShowCSVModal] = useState(false);

  useEffect(() => {
    //getAllProducts();
    getCorporateUsers();
    getProductCategories();
  }, []);

  useEffect(() => {
    if (formData.categoryId && formData.userId?.value) {
      getProductsByCategory(formData.categoryId, formData.userId?.value);
    } else {
      setProductsByCategory([]);
    }
  }, [formData.categoryId, formData.userId]);

  // const getAllProducts = () => {
  //   setLoading(true);
  //   axios
  //     .get("/escape-bucks/escape-bucks-products")
  //     .then((res) => {
  //       setLoading(false);
  //       if (res.data.status) {
  //         setAllProducts(res.data.data);
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       console.error(err);
  //     });
  // };

  const getProductsByCategory = (categoryId, userId) => {
    setLoading(true);
    axios
      .get(`/escape-bucks/escape-bucks-products?userId=${userId}&categoryId=${categoryId}`, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setProductsByCategory(res.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const getProductCategories = () => {
    axios
      .get("/escape-bucks/get-product-categories?status='true'", adminConfig())
      .then((res) => {
        if (res.data.status) {
          setProductCategories(res.data.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCorporateUsers = () => {
    axios
      .get("/get-all-corporate-tvi-users", adminConfig())
      .then((res) => {
        if (res.data.status) {
          // setCorporateUsers(res.data.data || []);
          let copUser = res.data?.data?.map((item) => {
            return { value: item?.userId, label: `${item.username} (${item.userEmail} , ${item.userNameAttr})` };
          });
          setCorporateUsers(copUser);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      ...(name === "categoryId" ? { productId: "" } : {}),
      [name]: value,
    }));
  };

  const handleClose = () => {
    setShowModal(false);
    setShowCSVModal(false);
    setFormData({ userId: {}, categoryId: "", productId: "", count: "" });
  };

  const getAllCode = useCallback(() => {
    setLoading(true);
    axios
      .get(
        `/escape-bucks/escape-bucks-product-codes-for-admin?page=${page}&limit=${limit}&search=${search}`,
        adminConfig(),
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const { data, pagination } = res.data;
          setAllCode(data);
          setTotal(pagination.total);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error("Something went wrong");
      });
  }, [page, limit, search]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const { count } = formData;

    if (!count || isNaN(count) || count <= 0) {
      message.error("Please enter a valid code count");
      return;
    }

    handleClose();
    setLoading(true);

    const data = {
      userId: formData.userId?.value,
      categoryId: formData.categoryId,
      productId: formData.productId,
      count,
    };

    axios
      .post("/escape-bucks/generate-unique-code", data, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          getAllCode();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err?.err?.message || err.message || "Error generating code");
        message.error(err?.err?.message || err.message || "Error generating code");
      });
  };

  useEffect(() => {
    getAllCode();
  }, [page, limit, search, getAllCode]);

  const columns = [
    {
      name: "Corporate User",
      selector: (row) => row?.corporateUser?.name,
    },
    {
      name: "Category",
      selector: (row) => row?.productCategory?.name,
    },
    {
      name: "Name",
      selector: (row) => row?.product?.name,
    },
    {
      name: "Code",
      selector: (row) => row.code,
    },
    {
      name: "Status",
      selector: (row) => (row.status ? "Active" : "Inactive"),
    },
  ];

  const exportCSV = (id) => {
    setLoading(true);
    handleClose();
    axios
      .get(`/escape-bucks/csv-escape-bucks-product-codes/${id}`, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            CorporateUserName: member?.userId?.name,
            CategoryName: member?.categoryId?.name,
            Name: member?.productId?.name,
            Code: member?.code,
            Status: member?.status ? "Active" : "Inactive",
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Corporate User Name", key: "CorporateUserName" },
    { label: "Category Name", key: "CategoryName" },
    { label: "Name", key: "Name" },
    { label: "Code", key: "Code" },
    { label: "Status", key: "Status" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <Modal show={showModal} centered>
        <Modal.Header>
          <Modal.Title>Generate New Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleOnSubmit}>
          
            <Form.Group className="mb-3">
              <Form.Label>Corporate User</Form.Label>
              {/* <Form.Control
                as="select"
                name="userId"
                value={formData.userId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Corporate User</option>
                {corporateUsers.map((user) => (
                  <option value={user.userId} key={user.userId}>
                    {user.username || `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.name || user.email} ({user?.userEmail})
                  </option>
                ))}
              </Form.Control> */}

              <Select
                options={corporateUsers}
                placeholder="Select Corporate User"

                name="userId"
                value={(formData.userId?.value) ? formData.userId : null}
                onChange={(e) => {
                  setFormData({ ...formData, userId: e });
                }} 
                required
              />

            </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Product Category</Form.Label>
              <Form.Control
                as="select"
                name="categoryId"
                value={formData.categoryId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Product Category</option>
                {productCategories.map((category) => (
                  <option value={category._id} key={category._id}>
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Select Product</Form.Label>
              <Form.Control
                as="select"
                name="productId"
                value={formData.productId}
                onChange={handleOnChange}
                required
                disabled={!formData.categoryId}
              >
                <option value="">Select Product</option>
                {productsByCategory.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Total Code</Form.Label>
              <Form.Control
                type="number"
                min="1"
                placeholder="Total Code"
                required
                name="count"
                value={formData.count}
                onChange={handleOnChange}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-3">
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="ms-3" type="submit" variant="primary">
                Generate Code
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* FOR EXPORT */}
      <Modal show={showCSVModal} centered>
        <Modal.Header>
          <Modal.Title>Select Product To Export CSV</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              exportCSV(formData.productId);
            }}
          >
            
            <Form.Group className="mb-3">
              <Form.Label>Corporate User</Form.Label>
              {/* <Form.Control
                as="select"
                name="userId"
                value={formData.userId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Corporate User</option>
                {corporateUsers.map((user) => (
                  <option value={user.userId} key={user.userId}>
                    {user.username || `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.name || user.email}
                  </option>
                ))}
              </Form.Control> */}

              <Select
                options={corporateUsers}
                placeholder="Select Corporate User"
                name="userId"
                value={(formData.userId?.value) ? formData.userId : null}
                onChange={(e) => {
                  setFormData({ ...formData, userId: e });
                }}
                required
              />

            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Product Category</Form.Label>
              <Form.Control
                as="select"
                name="categoryId"
                value={formData.categoryId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Product Category</option>
                {productCategories.map((category) => (
                  <option value={category._id} key={category._id}>
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Product</Form.Label>
              <Form.Control
                as="select"
                name="productId"
                value={formData.productId}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Product</option>
                {productsByCategory.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <div className="d-flex justify-content-end gap-3">
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="mx-3" type="submit" variant="primary">
                Export
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>

            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Escape Credits Products Code</h3>
                  <div className="ar_count">{total}</div>
                </div>

                <div className="sub_but mt-3">
                  <button
                    onClick={() => setShowModal(true)}
                    type="button"
                    className="add_but submit_buttt mt-0"
                  >
                    Generate New Code
                  </button>
                </div>

                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Search here ..."
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      disabled={!search}
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={() => {
                        setShowCSVModal(true);
                      }}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`escape_bucks_products_code_${new Date().toISOString()}.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={allCode}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationServer
                  paginationTotalRows={total}
                  paginationDefaultPage={page}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 50, 100, 300, 500]}
                  onChangeRowsPerPage={(limit) => {
                    setPage(1);
                    setLimit(limit);
                  }}
                  onChangePage={(page) => {
                    setPage(page);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};
